module.exports = __webpack_public_path__ + "static/media/naviguard_logo_footer.ccebdfc8.svg";